import _ from 'lodash';

export default class Helper
{
    public static nameOf<T>(name: keyof T): keyof T
    {
        return name;
    }

    private static _environment: string | null;
    public static get environment(): string
    {
        if (Helper._environment == null)
        {
            const currentUrl = window.location.href;
            if (currentUrl.includes('localhost'))
            {
                Helper._environment = "fadxpoc.iconics.cloud"
            }
            else
            {
                const splitUrl = currentUrl.split("/")
                const envVariable = splitUrl[2];
                const newSplitUrl = envVariable.split(".")
                Helper._environment = `${newSplitUrl[1]}.${newSplitUrl[2]}${newSplitUrl[3] ? '.' + newSplitUrl[3] : ''}`
            }
        }
        return Helper._environment;
    }

    public static getStorageUrl(): string
    {
        return `https://storage.${Helper.environment}`;
    }
}
